'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/react-dom/15.3.2/react-dom/index.js
 ** module id = 124
 ** module chunks = 0
 **/